import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IrbAppEvents } from '@irb/app.events';
import { IAlertDialogData } from '@irb/app.model';
import { AppService } from '@irb/app.service';
import { ISecurity } from '../irb-models.model';
import { SecurityMasterService } from '../security-master/security-master.service';
import { Subscription, interval } from 'rxjs';

@Component({ standalone: false,
  selector: 'irb-delete-securities-dialog',
  templateUrl: './delete-securities-dialog.component.html',
  styleUrls: ['./delete-securities-dialog.component.scss']
})
export class DeleteSecuritiesDialogComponent implements OnInit {
  deleteSecurities: Array<any>;
  deleteContinueFunction: Function;
  deleteSecurity: any=[] ;
  securityDetails: any=[];
  checkDeleteSelectedSecuritiesSub: Subscription;
  isUiTest = false;

  constructor(public dialogRef: MatDialogRef<DeleteSecuritiesDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private as: AppService,private readonly securityMasterService:SecurityMasterService) { }

  ngOnInit(): void {
    this.deleteSecurities = this.data.deleteSecurities as Array<ISecurity>;
    if(this.data.softdDeleteSecurities)
    {
      this.deleteSecurities = this.data.softdDeleteSecurities as Array<ISecurity>;

    }
    if(this.data.cashdeleteSecurities)
    {
      this.deleteSecurities = this.data.cashdeleteSecurities as Array<ISecurity>;
    }
    this.getDeletedSecurities();
    this.deleteContinueFunction = this.data.deleteContinueFunction || null; 
  }

  getDeletedSecurities() {
    for (let i = 0; i < this.deleteSecurities.length; i++) {
      this.deleteSecurity =
      {
        securityId: this.deleteSecurities[i].securityId,
        versionId: this.deleteSecurities[i].versionId
      }
      this.securityDetails.push(this.deleteSecurity);
    }

  }

  close() {
    if(this.dialogRef.close != undefined)
     this.dialogRef.close();
  }

  deleteSelectedSecurities() {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.securityMasterService.deleteSelectedSecurities(this.securityDetails).subscribe(res => {
      if(res.responseUtilityMap?.statusId) {
        this.checkDeleteSelectedSecuritiesStatus(res.responseUtilityMap.statusId);
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  checkDeleteSelectedSecuritiesStatus(statusId: string) {
    const intervalVal =  this.isUiTest ? 0 : 3000;
    this.checkDeleteSelectedSecuritiesSub = interval(intervalVal).subscribe(() => {
      this.securityMasterService.getDeleteSelectedModelStatus(statusId).subscribe((res: any) => {
        if(res.responseStatus.toUpperCase() == "SUCCESS" && res.responseUtilityMap.requestStatus.toUpperCase() == "COMPLETED") {
          this.checkDeleteSelectedSecuritiesSub.unsubscribe();
          this.completeDeleteSelectedSecurities(res);
        } else if (res.responseStatus.toUpperCase() == "STALEDATAEXCEPTION") {
          this.checkDeleteSelectedSecuritiesSub.unsubscribe();
          this.refreshRequired();
        }
      });
    });
  }

  completeDeleteSelectedSecurities(_res: any) {
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
   
    const dtlMsg = _res.responseData === 1 ? "1 security deleted." : _res.responseData + " securities deleted.";
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'warn',
      summary: "", 
      detail: dtlMsg
    });

    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);    
    this.close();
  }

  refreshRequired(){
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        dTitle: 'Refresh Required',
        dProceedBtnLabel: 'Refresh',
        msg: "You are attempting to create or update securities that was just modified by someone else. To see the updated securities, you need to refresh the page.",
        onProceed: () => {this.as.fireEvent(IrbAppEvents.GRID_REFRESH);}
    } as IAlertDialogData);
  }
}
